import { Flex } from "@simplybusiness/mobius";
import type { QuoteCardHeaderProps } from "../../types";
import { Ratings } from "../Ratings";
import { BindRestriction } from "./BindRestriction";

export const Header = ({
  logo,
  insurerName,
  insurerFinancialStrengthRatings: ratings,
  offlinePurchaseOnly,
  offlinePurchaseOnlyText,
  offlinePurchaseOnlyNumber,
  offlinePurchaseOnlyRfq,
}: QuoteCardHeaderProps) => {
  // Only these two fields are mandatory for a rating to be displayed
  const showRatings = ratings?.rating && ratings?.ratingType;
  const logoAltText = insurerName
    ? `${insurerName} insurer logo`
    : "Provider logo";

  const showBindRestrictions =
    !!offlinePurchaseOnly &&
    !!offlinePurchaseOnlyText &&
    !!offlinePurchaseOnlyNumber;

  return (
    <Flex
      flexDirection="column"
      gap="xxs"
      className="mobius-quote-card__header"
    >
      <BindRestriction
        offlinePurchaseOnlyRfq={offlinePurchaseOnlyRfq}
        showBindRestrictions={showBindRestrictions}
      />
      {logo && (
        <img
          src={logo}
          alt={logoAltText}
          className="mobius-quote-card__header-logo"
        />
      )}
      {showRatings && <Ratings data={ratings} />}
    </Flex>
  );
};
